export const TRIP_REQUEST_SEARCH_TERM_KEY = "trip_request_search_term";
export const HISTORIC_TRIPS_SEARCH_TERM_KEY = "historic_trips_search_term";
export const TRIP_REQUEST_FILTERS_KEY = "trip_request_filters";
export const HISTORIC_TRIPS_FILTERS_KEY = "historic_trips_filters";

export const clearTripSearchStorage = () => {
  localStorage.removeItem(TRIP_REQUEST_SEARCH_TERM_KEY);
  localStorage.removeItem(HISTORIC_TRIPS_SEARCH_TERM_KEY);
};

export const clearHistoricSearchStorage = () => {
  localStorage.removeItem(HISTORIC_TRIPS_SEARCH_TERM_KEY);
};

export const clearHistoricFiltersStorage = () => {
  localStorage.removeItem(HISTORIC_TRIPS_FILTERS_KEY);
};
